import { Auth } from "aws-amplify";

export async function getCurrentUserEmail() {
    const user = await Auth.currentAuthenticatedUser();
    const email = user.attributes.email;
    return email;
}
